<script setup lang="ts">
import { computed } from 'vue';
import { container } from '@shared/common/dependency-injection/domain/container';
import FormFieldMessages from '@shared/common/form/application/component/FormFieldMessages.vue';
import type { MoneyFormField } from '@shared/common/form/domain/form/field/money.form-field';
import type { FormFieldMoneyComponent } from '@shared/common/form/application/component/money/form-field-money-component.types';
import { FormDependencyTypes } from '@shared/common/form/form.dependency-types';

const EURO_ICON = 'fas fa-euro-sign';

const model = defineModel<MoneyFormField>({ required: true });
const component = container.get<FormFieldMoneyComponent>(FormDependencyTypes.FormFieldMoneyComponent);

const message = computed(() => model.value.errorMessages?.[0]);
const additionalErrors = computed(() => model.value.errorMessages?.slice(1));

function updateValue(value: string): void {
  model.value.value = value;
}
</script>

<template>
  <div>
    <component
      :is="component"
      :model-value="model.value ?? undefined"
      :label="model.label"
      :hint="model.hint"
      :placeholder="model.placeholder"
      :required="model.required"
      :disabled="model.disabled"
      :error="message"
      :message="message"
      :icon="EURO_ICON"
      @update:model-value="updateValue"
    />
    <FormFieldMessages :errors="additionalErrors" />
  </div>
</template>
